<template>
  <svg
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    class="background"
    ref="svg"
  >
    <defs>
      <pattern
        :id="`Pattern-${props.isTimeline? 'a':'b'}`"
        :x="state.containerPadding + '%'"
        y="0"
        :width="state.rectWidth + '%'"
        :height="state.rectHeight + '%'"
      >
      <!-- horizontal line -->
        <line
          v-if="!props.isTimeline"
          x1="0"
          y1="0"
          x2="100%"
          y2="0"
          fill="none"
          stroke="var(--scala-grigi-gray-3)"
          stroke-width=".3"
        />
        <!-- mask -->
        <rect
          x="0"
          y="0"
          :width="100 + '%'"
          height="100%"
          fill="#fff"
          v-if="props.isTimeline"
        />
        <!-- vertical line -->
        <line
          x1="0"
          y1="0"
          :x2="0"
          y2="100%"
          fill="none"
          stroke="var(--scala-grigi-gray-3)"
          stroke-width=".3"
        />
      </pattern>
    </defs>
    <rect :fill="`url(#Pattern-${props.isTimeline? 'a':'b'})`" width="100%" height="100%" x="0" y="0"></rect>
  </svg>
</template>

<script setup>
import { onMounted, inject, watch, reactive, ref, defineProps } from "vue";

const props = defineProps({
  isTimeline: { type: Boolean, default: false },
});

const tvaMq = inject("$tvaMq");
const svg = ref(null);

const state = reactive({
  responsiveSubdivision: 7,
  rectWidth: 0,
  rectHeight: 0,
  containerPadding: 23.81 
});

const setresponsiveSubdivision = (tvaMq) => {
  switch (tvaMq) {
    case "mobile":
      state.responsiveSubdivision = 3;
      break;
    case "tablet":
      state.responsiveSubdivision = 6;
      break;
    case "desktop":
      state.responsiveSubdivision = 7;
      break;
    default:
      state.responsiveSubdivision = 7;
  }

  state.rectWidth = (100 - state.containerPadding * 2) / state.responsiveSubdivision;
};

watch(tvaMq, (tvaMq) => {
  setresponsiveSubdivision(tvaMq);
});
onMounted(() => {
  setresponsiveSubdivision(tvaMq.value);

  const setRectHeight = () => {
    let pageHeight = svg.value.getBoundingClientRect().height;
    let widthPX = (window.innerWidth / 100) * state.rectWidth;

    state.rectHeight = (widthPX * 1.3 * 100) / pageHeight;
  };

  setTimeout(() => {
    setRectHeight();
  }, 500);

  window.addEventListener("resize", () => {
    setRectHeight();
  });
});
</script>

<style lang="scss" scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  overflow: visible;
}
</style>
